module.exports = __webpack_public_path__ + "static/media/home-wood-1@2x.ce342056.jpg";